import React from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import AboutUs from "./AboutUs";
import Services from "./Services";
import ProjectsSection from "./ProjectsSection";
import PackagesSection from "./PackagesSection";
import Gallery from "./Gallery";
import TestimonialsSection from "./TestimonialsSection";
import WhatsAppButton from "./WhatsAppButton";
import Contact from "./Contact";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";

export default function PublicWebsite() {
  return (
    <div className="w-full overflow-x-hidden relative">
      <style>
        {`
          html {
            scroll-behavior: smooth;
          }
        `}
      </style>

      {/* Main Studio Header */}
      <Header />
      
      {/* 1. Hero Section */}
      <div id="home">
        <HeroSection />
      </div>
      
      {/* 2. About Us Section */}
      <div id="about-us">
        <AboutUs />
      </div>
      
      {/* 3. Services Section */}
      <div id="services">
        <Services />
      </div>

      {/* 4. Projects / Portfolio Section */}
      <div id="projects">
        <ProjectsSection />
      </div>

      {/* 5. Packages / Pricing Section */}
      <div id="packages">
        <PackagesSection />
      </div>
      
      {/* 6. Gallery Showcase Section */}
      <div id="gallery">
        <Gallery />
      </div>

      {/* 7. Client Reviews / Testimonials Section */}
      <div id="testimonials">
        <TestimonialsSection />
      </div>
      
      {/* 8. Contact & Enquiry Section */}
      <div id="contact">
        <Contact />
      </div>
      
      {/* Footer */}
      <Footer />

      {/* Floating Action Elements */}
      <WhatsAppButton />
      <ChatWidget />
    </div>
  );
}
